import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ArthaGateway from 'service/ArthaGateway';
import { Receipt, VoucherSummary } from 'service';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import { durations } from 'service/Utils';
import { useNavigate } from 'react-router';

export const Receipts = () => {
    const appdata = useSelector((state: RootState) => state.appdata);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [durationId, setDurationId] = useState<string>("4");
    const [receipts, setReceipts] = useState<Receipt[]>([]);
    const [voucherSummary, setVoucherSummary] = useState<VoucherSummary>();
    const [voucherType, setVoucherType] = useState<string>("receipt");
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalPages, setTotalPages] = useState<number>(5);
    const navigate = useNavigate();

    useEffect(() => {
        loadReceipts();
    }, [pageNumber]);

    useEffect(() => {
        setReceipts([]);
        loadReceiptsSummary();
        loadReceipts();
    }, [durationId, voucherType]);

    const loadReceipts = () => {
        setIsLoading(true);
        ArthaGateway
            .getReceipts(0, durationId, 0, 0, pageNumber, pageSize)
            .then((data) => {
                data.entries.map((receipt) => receipt.isExpanded = false);
                if (pageNumber > 1) {
                    setReceipts(receipts.concat(data.entries));
                }
                else {
                    setReceipts(data.entries);
                }

                setTotalPages(data.totalPages);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadReceiptsSummary = () => {
        setIsLoading(true);
        ArthaGateway
            .getReceiptsSummary(0, durationId, 0, 0)
            .then((data) => {
                setVoucherSummary(data);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const toggleExapnd = (target: Receipt) => {
        receipts.map((receipt) => {
            if (receipt.id === target.id) {
                receipt.isExpanded = !receipt.isExpanded;
            }
            else {
                receipt.isExpanded = false;
            }
        });
        setReceipts([...receipts]);
    }

    const viewReceipt = (receipt: Receipt) => {
        navigate("/receipt/" + receipt.id);
    }

    const currencyFormat = (value: number) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <div className='page-vouchers app-page-shell'>
            <div className='list-page-hero mb-3'>
                <div>
                    <div className='hero-label'>Collections</div>
                    <h2>Receipts</h2>
                    {/*<p>Review received payments and receipt history.</p>*/}
                </div>
                <div className='hero-actions'>
                    <button type='button' className="btn btn-light btn-sm" onClick={() => navigate("/receipt/new")}>Create New</button>
                </div>
            </div>

            <div className='app-panel mb-3'>
                <div className="row">
                    <div className="col-12 col-md-4 mb-2">
                        <label className='form-label'>Duration</label>
                        <select className="form-select" id="duration" value={durationId} onChange={(e) => setDurationId(e.target.value)}>
                            {durations.map((duration) => (
                                <option key={duration.value} value={duration.value}>{duration.label}</option>
                            ))}
                            <option value="-1">Other</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className='page-invoice-list app-panel'>
                <div className="row g-2 mb-3">
                    <div className="col-4">
                        <div className="summary-card">
                            <div className="label">Receipts</div>
                            <div className="value">{voucherSummary?.numberOfInvoices || 0}</div>
                        </div>
                    </div>
                    <div className="col-8">
                        <div className="summary-card">
                            <div className="label">Amount</div>
                            <div className="value">{currencyFormat(voucherSummary?.billAmount || 0)}</div>
                        </div>
                    </div>
                </div>
                <div className="accordion voucher-accordion" id="dealerAccordion">
                    {receipts && receipts.map((receipt) => (
                        <div className="accordion-item">
                            <h2 className="accordion-header" id={receipt.id.toString()} onClick={() => toggleExapnd(receipt)}>
                                <div className={receipt.isExpanded === true ? "accordion-button active bg-dark" : "accordion-button collapsed"}>
                                    <div className="accordion-voucher-header">
                                        <b>{receipt.voucherNumber}</b>
                                        {moment(receipt.date).isSame(moment(), 'day') &&
                                            <div className='badge bg-success badge-small badge-notice'>Today</div>
                                        }
                                        {moment(receipt.date).isSame(moment().add(-1, 'days'), 'day') &&
                                            <div className='badge bg-primary badge-small badge-notice'>Yesterday</div>
                                        }
                                        <div className='badge bg-success'>{currencyFormat(receipt.amount)}/-</div>
                                        <div className="date-info">{moment(receipt.date).format("DD MMM YYYY")}</div>
                                    </div>
                                </div>
                            </h2>
                            <div id={"r" + receipt.id.toString()} className={receipt.isExpanded === true ? "accordion-collapse show" : "accordion-collapse collapse"} aria-labelledby={"r" + receipt.id.toString()}>
                                <div className="accordion-body">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">
                                            Date
                                            <div className="fw-bold">{moment(receipt.date).format("DD MMM YYYY")}</div>
                                        </li>
                                        <li className="list-group-item">
                                            Amount
                                            <div className="fw-bold">{currencyFormat(receipt.amount)}/-</div>
                                        </li>
                                        <li className="list-group-item">
                                            Ref No.
                                            <div className="fw-bold">{receipt.referenceNumber}</div>
                                        </li>
                                        <li className="list-group-item">
                                            Notes
                                            <div className="fw-bold">{receipt.notes || '--'}</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {(totalPages > pageNumber) &&
                    <>
                        {isLoading &&
                            <div className="btn btn-dark w-100 text-center mt-2">
                                <div className="spinner-border text-light" role="status">
                                </div>
                            </div>
                        }
                        {!isLoading &&
                            <div className="btn btn-outline-dark w-100 text-center mt-2" onClick={() => setPageNumber(pageNumber + 1)}>Load More...</div>
                        }
                    </>
                }
            </div>
        </div>
    );
};
